import script from "./ManagedSolutions.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagedSolutions.vue?vue&type=script&setup=true&lang=js"

import "./ManagedSolutions.vue?vue&type=style&index=0&id=56f14614&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f14614"]])

export default __exports__